import { Box } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import LocationContext from "@context/location/locationContext";

import InfoCard from "@src/components/shared-ui-components/InfoCard";
import { getApiResponse } from "@src/utils/service";
import ShowErrorToastContext from "@context/showErrorToast/showErrorToastContext";
import { message } from "@src/constants";
import { getCustomExtraPathMainDashboard } from "@pages/Dashboard/helper";
import SettingsContext from "@context/Settings/settingsContext";
import {
  StyledRootBox,
  StyledTypography,
  StyledSalesRow,
  StyledRowBox,
} from "./styles";
import { defaultCogs, getRefinedData } from "./helper";
import { LastUpdatedWrapper } from "../LastUpdated/style";
import LastUpdated from "../LastUpdated";

const CogsCard = () => {
  const [cogsData, setCogsData] = useState<CogsSummaryDataTypes>(defaultCogs);
  const {
    totalCogs,
    targetCogs,
    totalFoodCogs,
    totalAlcoholCogs,
    lastUpdated,
  } = cogsData;

  const [loading, setLoading] = useState(true);
  const [{ locationState }] = useContext(LocationContext);

  const [{ settingsState }] = useContext(SettingsContext);

  const { planData, foreCastData } = settingsState;

  const [{ showErrorToastSetState }] = useContext(ShowErrorToastContext);
  const { property, store, revenueCenter, date } = locationState;
  const filters = {
    property,
    store,
    rvc: revenueCenter,
    date,
    planData,
    foreCastData,
  };

  const filter = getCustomExtraPathMainDashboard(filters);

  useEffect(() => {
    (async () => {
      setLoading(true);
      const { data, error } = await getApiResponse(`cogs-summary${filter}`);
      setLoading(false);
      if (data !== null) {
        const refineData = getRefinedData(data);
        setCogsData(refineData);
      } else if (data === null) {
        showErrorToastSetState({
          errorMessage: error || "",
          errorTitle: message.ERROR_MESSAGE_DASHBOARD,
          open: true,
        });
      }
    })();
  }, [property, date, revenueCenter, store]);

  return (
    <StyledRootBox>
      <Box>
        <StyledTypography>COGS Summary</StyledTypography>
      </Box>
      <StyledRowBox>
        <StyledSalesRow>
          <InfoCard
            title="Total COGS"
            sales={totalCogs?.act}
            percentage={totalCogs?.pct}
            loading={loading}
            isInteger
          />
          {!revenueCenter && (
            <InfoCard
              title="Target COGS"
              sales={targetCogs?.act}
              percentage={targetCogs?.pct}
              loading={loading}
              isInteger
            />
          )}
        </StyledSalesRow>
        <StyledSalesRow>
          <InfoCard
            title="Total Food COGS"
            sales={totalFoodCogs?.act}
            percentage={totalFoodCogs?.pct}
            loading={loading}
          />
          <InfoCard
            title="Total Alcohol COGS"
            sales={totalAlcoholCogs?.act}
            percentage={totalAlcoholCogs?.pct}
            loading={loading}
          />
        </StyledSalesRow>
      </StyledRowBox>
      <LastUpdatedWrapper>
        <LastUpdated loading={loading} lastUpdatedTime={lastUpdated} />
      </LastUpdatedWrapper>
    </StyledRootBox>
  );
};

export default CogsCard;
